<script setup lang="ts">
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';
import { addOpus } from '~/api';

const toEditor = () => {
  // 未登录跳转登录
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    // 接入场景和角色等接口
    loginTask.add({
      type: IAfterLoginActionType.CREATE_WORK_WITH_PRESET,
      payload: {},
    });
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
    return;
  }
  return addOpus({}).then(result => {
    if (result) {
      const data = result.data as any;
      window.open(`/editor/${data.id}/${data.secret_id}`, '_blank');
    }
  });
};
</script>

<template>
  <ArrowBtn text="立即体验编辑" variant="black-middle" @click="toEditor" />
</template>
